import React, { useRef, useEffect } from 'react';
import MapController from './Controller';
import _s from './index.less';

import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';

const Map = ({ plan, onChange, onLoad, refController }) => {
  const mapContainer = useRef(null);
  const map = useRef(null);

  useEffect(() => {
    if (map.current) {
      if (plan) map.current.setPlan(plan);
      return;
    }
    const controller = new MapController({ ref: mapContainer, plan });
    controller.enableGeocoder();
    if (onChange) controller.setHandler(onChange);
    if (onLoad) controller.onLoad = onLoad;
    if (refController) refController.current = controller;
    map.current = controller;
  }, [plan]);

  return <div ref={mapContainer} className={_s.mapContainer} style={{ height: '100%' }} />;
};

export default Map;
